import MojitoCore from 'mojito/core';
import MojitoPresentation from 'mojito/presentation';

const UIViewImplementation = MojitoCore.Presentation.UIViewImplementation;
const { FlexPane, ToggleButton, Image } = MojitoPresentation.Components;

export default class FreeBetView extends UIViewImplementation {
    constructor() {
        super();
        this.onToggle = this.onToggle.bind(this);
    }

    onToggle() {
        this.props.toggleCallback(this.props.freeBet);
    }

    render() {
        return (
            <FlexPane config={this.config.container} class="ta-freebetContainer">
                <Image
                    config={this.config.icon}
                    class="ta-freebetIcon"
                    fill={
                        this.props.selected
                            ? this.config.iconColor.active
                            : this.config.iconColor.inactive
                    }
                />
                <ToggleButton
                    value={this.props.selected}
                    disabled={this.props.disabled}
                    onToggle={this.onToggle}
                    config={this.config.toggleButton}
                    label={this.props.title}
                    class="ta-FreeBetToggleButton"
                />
            </FlexPane>
        );
    }
}
